const supportFeatures = [
  {
    title: '1分30円 話した分だけ！',
    description: '月額固定費はゼロ。使った分だけのお支払いだから、無駄がありません。',
    icon: '/lp-img/support-icon-price.webp',
  },
  {
    title: 'ご自宅から、いつでも',
    description: '場所を選ばず、思い立ったときに相談できます！外に出かけたり、しなくてもいい！',
    icon: '/lp-img/support-icon-home.webp',
  },
  {
    title: '解決しなければ、返金',
    description: 'もし悩みが解決しなかった場合は、お支払い分を全額返金します！',
    icon: '/lp-img/support-icon-refund.webp',
  },
];

const supportCategories = [
  { label: 'たっぷ設定', icon: '/lp-img/support-cat-setting.webp' },
  { label: 'カメラ', icon: '/lp-img/support-cat-camera.webp' },
  { label: '詐欺メール', icon: '/lp-img/support-cat-scam.webp' },
  { label: '通販サイト', icon: '/lp-img/support-cat-shopping.webp' },
  { label: '行政手続き', icon: '/lp-img/support-cat-gov.webp' },
  { label: 'LINE使い方', icon: '/lp-img/support-cat-line.webp' },
  { label: 'メッセージ', icon: '/lp-img/support-cat-message.webp' },
  { label: '文字入力', icon: '/lp-img/support-cat-typing.webp' },
  { label: 'QRコード', icon: '/lp-img/support-cat-qr.webp' },
];

export default function Support() {
  return (
    <section className="lp__support" id="support">
      <div className="lp__support-header">
        <svg className="lp__support-arch" viewBox="0 0 300 162" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <path id="archTop" d="M 25,115 Q 150,10 275,115" fill="none" />
            <path id="archBottom" d="M 25,160 Q 150,55 275,160" fill="none" />
          </defs>
          <text className="lp__support-arch__text">
            <textPath href="#archTop" startOffset="50%" textAnchor="middle">スマホで困ったこと</textPath>
          </text>
          <text className="lp__support-arch__text lp__support-arch__text--sub">
            <textPath href="#archBottom" startOffset="50%" textAnchor="middle">ぜ～んぶ聞ける</textPath>
          </text>
        </svg>
        <p className="lp__support-en">Support</p>
        <h2 className="lp__support-heading">スマホなんでもサポート</h2>
      </div>

      <div className="lp__support-image">
        <img src="/lp-img/support-main.webp" alt="サポートイメージ" loading="lazy" />
      </div>

      <div className="lp__support-text">
        <p>
          たっぷのことだけでなく<br />
          他のアプリの使い方<br />
          行政のオンライン手続き<br />
          スマホで困ったこと――<br />
          ネットにまつわるあらゆる悩みを<br />
          オンラインでサポートします。
        </p>
      </div>

      <div className="lp__support-features">
        {supportFeatures.map((f) => (
          <div className="lp__support-feature" key={f.title}>
            <div className="lp__support-feature__icon">
              <img src={f.icon} alt="" loading="lazy" />
            </div>
            <div className="lp__support-feature__body">
              <h3 className="lp__support-feature__title">{f.title}</h3>
              <p className="lp__support-feature__desc">{f.description}</p>
            </div>
          </div>
        ))}
      </div>

      <h3 className="lp__support-anything">＼ どんなことでも!! ／</h3>

      <div className="lp__support-grid">
        {supportCategories.map((cat) => (
          <div className="lp__support-grid__item" key={cat.label}>
            <div className="lp__support-grid__icon">
              <img src={cat.icon} alt="" loading="lazy" />
            </div>
            <span className="lp__support-grid__label">{cat.label}</span>
          </div>
        ))}
      </div>

      <p className="lp__image-note">※写真はイメージです</p>

      <a href="https://pichipichipet-digisapo.web.app/" className="lp__support-cta" target="_blank" rel="noopener noreferrer">
        スマホなんでもサポート サイトへ →
      </a>
    </section>
  );
}
